import { render } from "./BaseFormError.vue?vue&type=template&id=2210d8e6"
import script from "./BaseFormError.vue?vue&type=script&lang=js"
export * from "./BaseFormError.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__